document.addEventListener('DOMContentLoaded', function(e) {
    let productImg1 = document.querySelector('.entry-main-img img');
    let productImg2 = document.querySelector('.entry-main-img img.alt');
    let swapTo = 2;
    
    if (productImg1 && productImg2) {
        let productImages = document.querySelectorAll('.woocommerce-product-gallery__image a');

        productImages.forEach(img => {
            img.addEventListener('click', async function(e) {
                e.preventDefault();
                let source = img.getAttribute('href');

                if (swapTo == 2) {
                    productImg2.setAttribute('src', source);
                    await handler(productImg2);
                    productImg2.classList.remove('alt');
                    productImg1.classList.add('alt');
                    swapTo = 1;
                } else {
                    productImg1.setAttribute('src', source);
                    await handler(productImg1);
                    productImg1.classList.remove('alt');
                    productImg2.classList.add('alt');
                    swapTo = 2;
                }
            })
        })

        let swatches = document.querySelectorAll('.thwvsf-wrapper-item-li');

        swatches?.forEach(swatch => {
            swatch.addEventListener('click', async (e) => {
                let newImg = document.querySelector('.woocommerce-product-gallery__image:first-child a img');
                await handler(newImg);

                if (swapTo == 2) {
                    productImg2.setAttribute('src', newImg.dataset.src);
                    await handler(productImg2);
                    productImg2.classList.remove('alt');
                    productImg1.classList.add('alt');
                    swapTo = 1;
                } else {
                    productImg1.setAttribute('src', newImg.dataset.src);
                    await handler(productImg1);
                    productImg1.classList.remove('alt');
                    productImg2.classList.add('alt');
                    swapTo = 2;
                }
            })
        })

        let clearVariation = document.querySelector('.reset_variations');

        clearVariation?.addEventListener('click', async (e) => {
            let newImg = document.querySelector('.woocommerce-product-gallery__image:first-child a img');
            await handler(newImg);

            if (swapTo == 2) {
                productImg2.setAttribute('src', newImg.dataset.src);
                await handler(productImg2);
                productImg2.classList.remove('alt');
                productImg1.classList.add('alt');
                swapTo = 1;
            } else {
                productImg1.setAttribute('src', newImg.dataset.src);
                await handler(productImg1);
                productImg1.classList.remove('alt');
                productImg2.classList.add('alt');
                swapTo = 2;
            }
        })
    }
})

async function handler(productImg) {
    return new Promise(resolve => {
        productImg.addEventListener('load', resolve, {once: true});
    })
}